<template>
  <div>
    <div class="flex">
      <div class="hidden sm:flex items-center w-18 flex-shrink-0">
        <button
          type="button"
          class="w-12 h-12 border border-guestio-gray-50 rounded-full flex items-center justify-center shadow-xl transition duration-150 ease-in-out"
          :class="{ 'bg-pink-500 border-pink-500': selected.length }"
          @click.prevent="toggleSelection"
        >
          <CheckIcon v-if="selected.length" class="h-8 text-white" />
        </button>
      </div>
      <div @click="toggleSelection" class="cursor-pointer bg-white flex-1 border border-guestio-gray-50 flex rounded-xl px-4 py-6 transition duration-150 ease-in-out" :class="{ 'border-pink-500': selected.length }">
        <div class="flex-shrink-0 flex justify-end px-3">
          <img :src="option.icon_url" class="h-8 w-8" alt="">
        </div>
        <div class="flex-1">
          <h3 class="font-bold text-xl text-blue-800">Live Show</h3>
          <p class="text-sm text-gray-500 mt-2">
            Shows can book you for their live streaming on Clubhouse, Facebook, Youtube or Instagram.
          </p>
        </div>
      </div>
    </div>

    <div v-if="selected.length" class="pl-0 sm:pl-20 mt-6 flex items-start overflow-hidden">
      <div class="flex items-center">
          <div>
            <ValidationProvider rules="required" name="Time slot duration" v-slot="{ errors }">
              <div
                class="rounded-full bg-white py-3 md:px-5 px-2 flex items-center border border-guestio-gray-50"
                :class="{'border border-red-500': errors.length}"
              >
                <ClockIcon class="mr-3 flex-shrink-0"/>
                <select class="bg-transparent" v-model="selected[0].interview_duration">
                  <option
                    v-for="duration in availableDurations"
                    :value="duration"
                    :key="`duration-option-${duration}`"
                  >{{ duration }}</option>
                </select>
              </div>
            </ValidationProvider>
          </div>

          <div class="hidden md:block ml-2">
            <span>minutes</span>
          </div>
        </div>

        <div class="ml-6 xl:ml-12 flex items-center">
          <div>
            <ValidationProvider name="Price" v-slot="{ errors }" rules="required|min_value:5">
              <div
                class="rounded-full bg-white py-3 px-5 flex items-center md:w-32 border border-guestio-gray-50"
                :class="[{'border border-red-500': errors.length}]"
              >
                <DollarSignIcon class="mr-3 flex-shrink-0"/>
                <input
                  id="price"
                  type="number"
                  min="5"
                  oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                  class="bg-transparent w-full"
                  v-model="selected[0].price"
                >
              </div>
              <p class="form-error text-red-500 text-sm mt-1 font-light" v-if="errors.length">{{ errors[0] }}</p>
            </ValidationProvider>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  import CheckIcon from '@/components/svgs/CheckIcon'
  import DollarSignIcon from '@/components/svgs/DollarSignIcon'
  import ClockIcon from '@/components/svgs/ClockIcon'

  export default {
    name: 'LivePlatformOption',

    props: {
      option: Object,

      prices: {
        type: Array,
        default: () => ([])
      },
    },

    components: {
      CheckIcon,
      DollarSignIcon,
      ClockIcon,
    },

    data() {
      return {
        selected: [],

        defaultItem: {
          booking_option_id: this.option.id,
          price: 100,
          interview_duration: 120,
        }
      }
    },

    computed: {
      availableDurations() {
        return this.$store.getters['guest/availability/availableDurations']
      },
    },

    watch: {
      selected: {
        deep: true,
        handler(selected) {
          this.$emit('updated', selected)
        }
      }
    },

    methods: {
      toggleSelection() {
        if (this.selected.length) {
          this.selected = []
          return
        }

        this.selected.push({
          ...this.defaultItem
        })
      },
    },

    mounted() {
      if (this.prices && this.prices.length) {
        this.selected = [...this.prices]
      }
    }
  }
</script>
